import { useMemo } from "react";
import { object, array } from "yup";
import { FormField } from "./types";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.Methods]: array()
                .required()
                .min(1, 'At least one payment method is required')
                .label('Payment Methods')
        })
    ), []);

export default useValidationSchema;

